import React, { Fragment, useEffect, useState } from 'react';
import { Col, Row, TabContent, TabPane } from 'reactstrap';
import profile_img from "../../assets/images/man_profile.jpg";
import moment from 'moment';
import { activateDeactivateStaff, getStaffsById} from '../../api/User';
import { useDispatch, useSelector } from 'react-redux';
import { failed, success } from '../../utils/Tostify';
import Loader from '../../components/Loader/Loader';
import EditUser from '../users/user/EditUser';
import { decryptData } from '../../utils/helper';
import { useConfirmDialog } from '../../hooks/useConfirmDialog';
import "../../modules/users/user/Users.css";
import { useLocation, useNavigate } from 'react-router';

function OrgUserDetails({ direction, setCurrentTab, ...args }) {
    let token = useSelector(state => state.userReducer.token);
    const { getConfirmation } = useConfirmDialog();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const userDetailsData = location?.state;
    const userIdFromState = location.state?.id;
    const userId = location?.state?.id || userDetailsData?._id;
    const [user, setUser] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const handleActiveInActive = async(e, staffId)=>{
        const currentChecked = e.target.checked;
        e.target.checked = !currentChecked;
        let msg = currentChecked === true ? "Activate" : "Deactivate";
        const confirmed = await getConfirmation({
            title: "Attention!",
            entryName: "",
            actionBtnTitle: "Yes",
            message : `Are you sure want to ${msg}`
        });
        if(confirmed){
            let res;
            try {
              setIsLoading(true);
              res = await activateDeactivateStaff({dispatch, token, staffId, isActive: currentChecked});
              if (res?.status === "SUCCESS") {
                  setIsLoading(false);
                  getUser();
                  success(res?.message);
              }else{
                setIsLoading(false);
                failed(res?.message);
              }
          } catch (error) {
              console.log("error", error);
              setIsLoading(false);
              failed(res?.message);
          }
        }else{
            e.target.checked = !currentChecked;
        }
    };

    const getUser = async () => {
        let res;
        try {
          setIsLoading(true);
        //   setSearch(searchKey);
          res = await getStaffsById({ dispatch, token, userId});
          const responseData = decryptData(res?.data);
          if (res?.status === "SUCCESS") {
            setUser(responseData);
            setIsLoading(false);
          }
        } catch (error) {
          failed(res?.message);
          setIsLoading(false);
        }
    };

    useEffect(() => {
    if (userId) {
      getUser();
    }
  }, [userId]);
    return (
        <Fragment>
            {isLoading && <Loader/>}
            {showModal && <EditUser refetch={getUser} userData={user} setShowModal={() => setShowModal(!showModal)} setCurrentTab={setCurrentTab}/>}
            {user && <div className='organization_view_details'>
                <div className='userdetails_container paginator_blk'>
                        <TabContent activeTab={"1"}>
                            <TabPane tabId="1">
                                <Row>
                                    <Col sm="12">
                                        <div className='profile_block user_details_blockk m-0'>
                                            <div className='profile_main d-flex justify-content-between align-items-center flex-wrap gap-3'>
                                                <div className='profile_info flex-wrap'>
                                                    <img src={profile_img} alt="img_profile" className="img_profile_one" />
                                                    <div>
                                                        <h6>{user?.firstName + " " + user?.lastName}</h6>
                                                        <p>{user?.email}</p>
                                                    </div>
                                                </div>
                                                <button className='edit_profile' onClick={()=> setShowModal(true)}>Edit</button>
                                            </div>
                                            <div className='data_profile'>
                                                <div className='row'>
                                                    <div className='col-lg-4 mb-3'>
                                                        <h4>Name</h4>
                                                        <p>{user?.firstName + " " + user?.lastName}</p>
                                                    </div>
                                                    <div className='col-lg-4 mb-3'>
                                                        <h4>Last Password Change or Reset</h4>
                                                        <p>03/02/2023, 12:20 PM</p>
                                                    </div>
                                                    <div className='col-lg-4 mb-3'>
                                                        <h4>Organization</h4>
                                                        <p>{userDetailsData?.organizationName}</p>
                                                    </div>
                                                    <div className='col-lg-4 mb-3'>
                                                        <h4>Department</h4>
                                                        <p>{user?.department}</p>
                                                    </div>
                                                    <div className='col-lg-4 mb-3'>
                                                        <h4>Create Date</h4>
                                                        <p>{moment(user?.createdAt).format("MMM-DD-YYYY") }</p>
                                                    </div>
                                                    <div className='col-lg-4 mb-3'>
                                                        <h4>User Role</h4>
                                                        <p>{user?.defaultRole?.label}</p>
                                                    </div>
                                                    <div className='col-lg-4 mb-3'>
                                                        <h4>Title</h4>
                                                        <p>Product Owner</p>
                                                    </div>
                                                    <div className='col-lg-4 mb-3'>
                                                        <h4>Reset Password</h4>
                                                        <p>Reset Password</p>
                                                    </div>
                                                    <div className='col-lg-4 mb-3'>
                                                        <h4>Phone</h4>
                                                        <p>{user?.primaryPhone}</p>
                                                    </div>
                                                    <div className='col-lg-4 mb-3'>
                                                        <h4 className='mb-2'>User Active</h4>
                                                        <p> <div className="toggle">
                                                            <input
                                                                type="checkbox"
                                                                id="checktoggle"
                                                                defaultChecked={user?.active}
                                                                checked={user?.active}
                                                                onChange={(e)=> handleActiveInActive(e, user?._id)}
                                                            />
                                                            <label htmlFor="checktoggle"></label>
                                                        </div></p>
                                                    </div>
                                                    <div className='col-lg-4 mb-3'>
                                                        <h4>Email</h4>
                                                        <p>{user?.email}</p>
                                                    </div>
                                                    <div className='col-lg-4 mb-3'>
                                                        <h4>Failed Login Attempts</h4>
                                                        <p>0</p>
                                                    </div>
                                                    <div className='col-lg-4 mb-3'>
                                                        <h4>Hospital</h4>
                                                        <p>{userDetailsData?.organizationName + "-" +  userDetailsData?.clinicName}</p>
                                                    </div>
                                                    <div className='col-lg-4 mb-3'>
                                                        <h4>Address</h4>
                                                        <p>{user?.city + "," + user?.state}</p>
                                                    </div>
                                            </div>                                                </div>

                                        </div>
                                    </Col>
                                </Row>
                            </TabPane>
                        </TabContent>
                </div>
                <div className="d-flex gap-3 justify-content-center mt-3">
                <button className="save_btn_blockk" type="submit" onClick={()=> navigate(-1)}>Back</button>
                </div>
            </div>}
        </Fragment>
    );
}

export default OrgUserDetails;
